import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { ComposeOperation } from 'owa-mail-compose-store';

export default function shouldAutoAddSignature(operation: ComposeOperation): boolean {
    const userOptions = getUserConfiguration().UserOptions;
    let autoAddSignature = false;
    switch (operation) {
        case ComposeOperation.New:
            autoAddSignature = userOptions.AutoAddSignature;
            break;
        case ComposeOperation.Reply:
        case ComposeOperation.ReplyAll:
        case ComposeOperation.Forward:
            autoAddSignature = userOptions.AutoAddSignatureOnReply;
            break;
    }

    return autoAddSignature;
}
